import {ColumnInstance} from 'react-table'
import {Role} from '../../core/_models'
import {QueryState} from '../../core/_models'
import clsx from 'clsx'

interface CustomColumnInstance<T extends object> extends ColumnInstance<T> {
  sortable?: boolean
  sortBy?: string
}

type Props = {
  column: CustomColumnInstance<Role>
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

const CustomHeaderColumn = ({column, state, updateState}: Props) => {
  const handleSort = () => {
    if (!column.sortable) return

    const isAsc = state.sort === column.sortBy && state.order === 'asc'
    updateState({
      sort: column.sortBy,
      order: isAsc ? 'desc' : 'asc'
    })
  }

  const isSelectedForSorting = state.sort === column.sortBy
  const order = state.order

  return (
    <th
      {...column.getHeaderProps()}
      className={clsx(
        column.sortable ? 'cursor-pointer' : '',
        isSelectedForSorting && order && `table-sort-${order}`
      )}
      style={{cursor: column.sortable ? 'pointer' : 'default'}}
      onClick={handleSort}
    >
      {column.render('Header')}
    </th>
  )
}

export {CustomHeaderColumn} 